import { render, staticRenderFns } from "./CustomerManagement.vue?vue&type=template&id=4bd3a258&scoped=true&"
import script from "./CustomerManagement.vue?vue&type=script&lang=ts&"
export * from "./CustomerManagement.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerManagement.vue?vue&type=style&index=0&id=4bd3a258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3a258",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VBtn,VCard,VCardTitle,VChip,VCol,VContainer,VDataTable,VIcon,VPagination,VRow,VSkeletonLoader,VSnackbar,VTextField,VWindow,VWindowItem})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd3a258')) {
      api.createRecord('4bd3a258', component.options)
    } else {
      api.reload('4bd3a258', component.options)
    }
    module.hot.accept("./CustomerManagement.vue?vue&type=template&id=4bd3a258&scoped=true&", function () {
      api.rerender('4bd3a258', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/CustomerManagement.vue"
export default component.exports